import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import MainLayout from "./components/Layout/MainLayout";
import { publicRoutes, privateRoutes } from "./routes";
import ProtectedRoute from "./utils/ProtectedRoute";

function App() {

  return (
    <AuthProvider>
      <Routes>
        {publicRoutes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          {privateRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
